require('common/js/sync-login');
require('common/js/GlobalConfig');
require('common/js/common-filter');
require('common/js/directive/all-directive');
require('common/js/common-util');
require('common/js/common-validator');



// WEBPACK FOOTER //
// ./src/common/js/common-include.js